/**
 * Arrivals/Departures table.
 *
 * The Call to the API has not yet taken place,
 * that's the reason for using JS to get the datetime
 * and place it in the correct spot.
 */
if ($('.flights-full-table').length > 0) {
    var $table = $('.flights-full-table table');
    var $date = $table.attr('data-updateddate');
    var $time = $table.attr('data-updatedTime');

    if ($('#update_date').length > 0) {
        $('#update_date').text($date);
    }

    if ($('#update_time').length > 0) {
        $('#update_time').text($time);
    }

    var refr_time = $('#update_time').text() + ":00";
    refr_time = refr_time.split(":");
    var refr_date = $('#update_date').text();

    var refr_datetime= refr_date + " " + refr_time;
    var dateParts = refr_date.split("/");

    var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    dateObject.setHours(refr_time[0], parseInt(refr_time[1]) + 2, parseInt(refr_time[2]) + 30);

    dateObject = Math.floor(dateObject.getTime());

    /**
     * Adding the refresh button if the data
     * is more than 2 minutes old
     */
    function show_refresh_button() {
        var currentdate = new Date();
        currentdate = Math.floor(currentdate.getTime());

        if ($("#hard_refresh").length <= 0 && currentdate >= dateObject) {
            if(window.location.href.indexOf("/bg/") > -1) {
                $('#flights_search_module__update').append("<button id='hard_refresh'>Обновяване</button>");
            } else {
                $('#flights_search_module__update').append("<button id='hard_refresh'>Refresh</button>");
            }

            $('#hard_refresh').click(function() {
                location.reload(true);
            });
        }

        setTimeout(function() {
            show_refresh_button();
        }, 10000);
    }
    show_refresh_button();


    /**
     * Page scrolls to flight with time around now
     */
    function show_nearest_flight () {
        let flights = $('.flights-full-table table tbody tr');
        const timeNow = Date.now();
        const halfHour = 1000 * 30 * 60;
        const halfHourAgo = Date.now() - halfHour;

        $.each(flights, function (index) {
            let current = flights[index];
            let flightTime = $(current).find('.flight-time').text() + ":00";
            flightTime = flightTime.split(":");
            let flightDate = $(current).find('.flight-date').text();
            flightDate = flightDate.split("/");

            let fl_time = new Date(+flightDate[2], flightDate[1] - 1, +flightDate[0]);
            fl_time.setHours(flightTime[0], parseInt(flightTime[1]), parseInt(flightTime[2]));
        
            fl_time = Math.floor(fl_time.getTime()); 
            
            if( fl_time > halfHourAgo && fl_time < timeNow ) {
                $(window).scrollTop($(current).offset().top);
                return false;
            }
        });
    }
    
    const currUrl = window.location.search;
    const urlParams = new URLSearchParams(currUrl);    

    if( urlParams.has('flights') ) {
        const flightParam = urlParams.get('flights');

        if (flightParam == 'now' || flightParam == 'scroll') {
            show_nearest_flight();  
        }               
    }    
}